if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: false,
      showPlaceholderProductList: true,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
      
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());

    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, true));
    
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    var compareHtml = '<label class="coder-compareder-compare coder-compare-checkbox"><input type="checkbox"><span>Compare</span></label>';
    itemHtml = itemHtml.replace(/{{itemCompare}}/g, compareHtml);
    console.log(compareHtml);
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    itemHtml = itemHtml.replace(/{{itemJson}}/g, buildWishlistHeroButton(data, Utils.buildProductItemUrl(data)));
    itemHtml = itemHtml.replace(/{{quickAdd}}/g, quckAddButton(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/

  
   // Build Wishlist Hero Button
function buildWishlistHeroButton(data, link) {

	try {
		//console.log(prodJsonString)
		let product = data;
		var image = product.images_info && product.images_info.length > 0 ? product.images_info[0].src : "";
		var name = product.title;
		var url = link;
		var price = product.price / 100;
		var selected_var_id = product.variants[0].id;
		var selected_var = product.variants[0];

		product.variants.forEach(function (possible_var) {
			if (possible_var.id == selected_var_id) {
				selected_var = possible_var;
				if (selected_var.featured_image && selected_var.featured_image.src) {
					image = selected_var.featured_image.src;
				}

				if (selected_var.url) {
					url = selected_var.url;
				}

				if (selected_var.name) {
					name = selected_var.name;
				}
				price = selected_var.price;
			}

		});

		let wishlistButton = document.createElement("div");
		wishlistButton.classList.add("wishlist-hero-bc-button");
		wishlistButton.classList.add("wishlisthero-bc-inline");

		wishlistButton.setAttribute("data-wlh-id", product.id);
		wishlistButton.setAttribute("data-wlh-link", url);
		wishlistButton.setAttribute("data-wlh-variantId", selected_var.id);
		wishlistButton.setAttribute("data-wlh-price", price);
		wishlistButton.setAttribute("data-wlh-name", name);
		wishlistButton.setAttribute("data-wlh-image", image);
		wishlistButton.setAttribute("data-wlh-mode", "icon_only");
      
		return wishlistButton.outerHTML;

	} catch (ex) {
		console.log(ex);
	}
}

  
  function buildImages(data) {
    console.log(data);
    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      html += '<div class="card__media">';
      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      if (data?.split_product) {
        origin_images = data.original_images;
      } else {
        origin_images = images;
      }
      var activeSwapImage = !Utils.isMobile() && origin_images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        console.log(data.title, images.length)

        if (activeSwapImage) {
          flipImageSrcSet += Utils.optimizeImage(origin_images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }

      aspectRatio = images[0]['width'] / images[0]['height'];
      html += '<div class="media media--transparent media--hover-effect"><img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + dataSrcSet + '" ' +
        'height="' + images[0].height + '" ' +
        'width="' + images[0].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + flipImageSrcSet + '" ' +
        'height="' + origin_images[1].height + '" ' +
        'width="' + origin_images[1].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(origin_images[1].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }


  // Start Boost 174327
  // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabels(data, showall) {
      if (showall) {
        var tagLabel = '';
        var labelArr = [];
        if (data.tags) {
          for (var i = 0; i < data.tags.length; i++) {
            var tag = data.tags[i];
            if (tag.indexOf("gb:") !== -1){
              var newTagArr = tag.split(':');
              var newTagLabel = newTagArr[0];
              var newTagValue = newTagArr[1];
              if(newTagLabel !== 'eyewear-style'){
                labelArr.push(newTagValue);
              }
            }
            /*else{
              if(tag.indexOf('Best Seller') !== -1 
                 || tag.indexOf('Sale') !== -1
                 || tag.indexOf('New Release') !== -1){
                labelArr.push(tag);
              }
            }
            */
          }
        }
      }

      if(labelArr.length > 0){
        var labelArrToString = labelArr.join(', ');
        tagLabel += '<span class="tag-show">'+ labelArrToString +'</span>';
      }
    
      return tagLabel;
  }
  // End Boost 174327

  function buildPrice(data) {
    var html = '';
    var productData = JSON.stringify(data).replace(/[']/g, "");
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min) : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    var productOptions = data.options_with_values;

    function filterByValue(array, string) {
      return array.filter(o =>
        Object.keys(o).some(k => o[k].toString().toLowerCase().includes(string.toLowerCase())));
    }
    // var productSizesArray = filterByValue(productOptions, 'Size');
    // if(productSizesArray) {
    //   var productSizes = productSizesArray[0].values;
    // }
    

    let hideBackInStock = false
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if(tag.indexOf('bis-nmwa') !== -1){
          hideBackInStock = true
        }
      }
    }
    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''} ${hideBackInStock ? 'hide-back-in-stock' : ''}">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${moneyPrice}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular">
                  ${compareAtPrice}
                </s>
              </span>
              <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
              <span class="price-item price-item--sale price-item--last">
                ${moneyPrice}
              </span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
          <a href="#" class="BIS_trigger" data-product-data='${productData}'>
            Notify Me When Available
          </a>
        </div>`
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }
    
  function getAspectRatio(data) {
    var width = (data == null) ? '535' : data.width;
    var height = (data == null) ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }
  // Quick add button 
  function quckAddButton(data) {
    //console.log('data pfs ',data);
    var html = `<div class="quick-add top-left my-custome-class-">
                  <product-form>
                    <form method="post" action="/cart/add" id="quick-add-template__${data.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <button id="quick-add-template__${data.id}-submit" type="button" name="add" data-title="Add to Demo List" class="button button--full-width button--secondary demo-pro-btn variant-popup-btn" aria-haspopup="dialog" aria-labelledby="quick-add-template__${data.id}-submit title-template__${data.id}" aria-live="polite" data-sold-out-message="true" data-id="${data.id}" data-hand-url="/products/${data.handle}" handle="${data.handle}">
                      <span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.601562 9.89863C0.601562 9.56629 0.857492 9.29688 1.1732 9.29688H9.17609C9.49179 9.29688 9.74772 9.56629 9.74772 9.89863C9.74772 10.231 9.49179 10.5004 9.17609 10.5004H1.1732C0.857492 10.5004 0.601562 10.231 0.601562 9.89863Z" fill="#212120"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.57831 10.5488C9.24598 10.5488 8.97656 10.2794 8.97656 9.94708V1.52256C8.97656 1.19022 9.24598 0.920808 9.57831 0.920808C9.91065 0.920808 10.1801 1.19022 10.1801 1.52256V9.94708C10.1801 10.2794 9.91065 10.5488 9.57831 10.5488Z" fill="#212120"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.58222 18.7178C9.24988 18.7178 8.98047 18.4484 8.98047 18.116V9.69151C8.98047 9.35917 9.24988 9.08975 9.58222 9.08975C9.91456 9.08975 10.184 9.35917 10.184 9.69151V18.116C10.184 18.4484 9.91456 18.7178 9.58222 18.7178Z" fill="#212120"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7383 9.8996C10.7383 9.56726 11.0342 9.29785 11.3992 9.29785H18.5373C18.9023 9.29785 19.1982 9.56726 19.1982 9.8996C19.1982 10.2319 18.9023 10.5014 18.5373 10.5014H11.3992C11.0342 10.5014 10.7383 10.2319 10.7383 9.8996Z" fill="#212120"></path>
                        </svg>
                      </span>
                      <div class="loading-overlay__spinner hidden">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>
                    </form>
                  </product-form>
                  <div class="plus-cart-icon-msg" style="display:none;"><span class="added-item-msg"></span></div>
                </div>`;
    return html;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

   // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    
    this.buildExtrasProductListByAjax(data, 'boost-pfs-integration', function(results) {
   // console.log(results)
    results.forEach(function(result) {
      var element = jQ('[data-id="' + result.id + '"]');
      element.find('.tagProduct').append(result.Tag.trim());
      //console.log(result.Tag)
      
    });
    //console.log('*****************************************************************************');
    $('.demo-prod-grid').find('.card__media').addClass('click_demo_popup');;
    demoProductCount();
  });

    
          // ===================================================================
          // Wishlist Hero Customization in ProductList.prototype.afterRender
        function loadWHIconsInPlace(){
          window.WH_INITIAL_TIMEOUT_PASSED= true;
          console.log("Checking icon ..");
          document
          .querySelectorAll(".wishlist-hero-bc-button")
          .forEach(function (wishlistButton) {
              var ev = new CustomEvent("wishlist-hero-add-to-custom-element", {
                  detail: wishlistButton,
              });
              document.dispatchEvent(ev);
          });
        }
     
      if(typeof(window.WH_INITIAL_TIMEOUT_PASSED) != "undefined"){
        loadWHIconsInPlace();
      }else{
       
          window.setTimeout(loadWHIconsInPlace,800);
          window.setTimeout(loadWHIconsInPlace,3000);
        window.setTimeout(loadWHIconsInPlace,5000);
        window.setTimeout(loadWHIconsInPlace,20000);
      }
     
      // ===================================================================

    
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
  };

  FilterOption.prototype.afterRender = function () {
    if(this.filterOptionId == "pf_m_::global::Paddle-Thickness" || this.filterOptionId == "pf_m_::global::Paddle-Weight") {
      jQ(this.$element).find('.boost-pfs-filter-option-value').css("text-transform", "lowercase")
    }
  }
  
   var newicon = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 21 12" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 2.9445C0 2.60699 0.273604 2.33339 0.611111 2.33339H4.31248C4.64999 2.33339 4.92359 2.60699 4.92359 2.9445C4.92359 3.28201 4.64999 3.55561 4.31248 3.55561H0.611111C0.273604 3.55561 0 3.28201 0 2.9445Z" fill="#212120"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.015625 9.05534C0.015625 8.71783 0.289229 8.44423 0.626736 8.44423H12.8692C13.2068 8.44423 13.4804 8.71783 13.4804 9.05534C13.4804 9.39285 13.2068 9.66645 12.8692 9.66645H0.626736C0.289229 9.66645 0.015625 9.39285 0.015625 9.05534Z" fill="#212120"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.35547 2.9445C7.35547 2.60699 7.62907 2.33339 7.96658 2.33339H20.1888C20.5263 2.33339 20.7999 2.60699 20.7999 2.9445C20.7999 3.28201 20.5263 3.55561 20.1888 3.55561H7.96658C7.62907 3.55561 7.35547 3.28201 7.35547 2.9445Z" fill="#212120"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9062 9.05534C15.9062 8.71783 16.1799 8.44423 16.5174 8.44423H20.184C20.5215 8.44423 20.7951 8.71783 20.7951 9.05534C20.7951 9.39285 20.5215 9.66645 20.184 9.66645H16.5174C16.1799 9.66645 15.9062 9.39285 15.9062 9.05534Z" fill="#212120"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.13976 4.16656C6.81477 4.16656 7.36198 3.61935 7.36198 2.94434C7.36198 2.26932 6.81477 1.72212 6.13976 1.72212C5.46474 1.72212 4.91753 2.26932 4.91753 2.94434C4.91753 3.61935 5.46474 4.16656 6.13976 4.16656ZM6.13976 5.38878C7.48979 5.38878 8.5842 4.29437 8.5842 2.94434C8.5842 1.59431 7.48979 0.499893 6.13976 0.499893C4.78973 0.499893 3.69531 1.59431 3.69531 2.94434C3.69531 4.29437 4.78973 5.38878 6.13976 5.38878Z" fill="#212120"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6944 10.2779C15.3695 10.2779 15.9167 9.73068 15.9167 9.05567C15.9167 8.38065 15.3695 7.83344 14.6944 7.83344C14.0194 7.83344 13.4722 8.38065 13.4722 9.05567C13.4722 9.73068 14.0194 10.2779 14.6944 10.2779ZM14.6944 11.5001C16.0445 11.5001 17.1389 10.4057 17.1389 9.05567C17.1389 7.70564 16.0445 6.61122 14.6944 6.61122C13.3444 6.61122 12.25 7.70564 12.25 9.05567C12.25 10.4057 13.3444 11.5001 14.6944 11.5001Z" fill="#212120"/>
</svg>` ;  
 
  FilterDesktopButton.prototype.compileTemplate = function () {
    return this.getTemplate()
			.replace(/{{filterTreeDesktopButton}}/g, Class.filterTreeDesktopButton)
			.replace(/{{label}}/g, 'Show Filters')
			.replace(/{{icon}}/g, newicon);
  }
  
  
  FilterDesktopButton.prototype.onClick = function() {
    if (typeof this.filterTree.onClickDesktopButton == 'function') {
			this.filterTree.onClickDesktopButton();
		} else {
			this.toggleFilterTree();
			jQ('body').toggleClass(Class.filterTreeOpenBody);
     
		}
  }
  
   FilterDesktopButton.prototype.toggleFilterTree = function() {
     var $toggleFilterTreeElement = jQ('#' + this.filterTree.id);
      if (!$toggleFilterTreeElement || $toggleFilterTreeElement.hasClass('toggling')) {
        return;
      }

      this.isCollapsed = !this.isCollapsed;

      if (Settings.getSettingValue('general.changeDesktopButtonLabel')) {
        this.label = this.isCollapsed ? Labels.refineDesktop : Labels.refineDesktopCollapse;
      this.$element[0].children[1].innerHTML = this.label;
        // this.$element[0].children[1].innerHTML = 'Show Filter';
      }
      if (Settings.getSettingValue('general.changeDesktopButtonIcon')) {
        // this.icon = this.isCollapsed ? Settings.getSettingValue('general.filterTreeIcon') : Settings.getSettingValue('general.filterTreeIconClose');
        // this.$element[0].children[0].innerHTML = this.icon;
        
        this.label = this.isCollapsed ? 'Show Filters' : 'Hide Filters';
      this.$element[0].children[1].innerHTML = this.label;
      }
      this.afterToggleFilterTree();
     }

  /************************** END BUILD TOOLBAR **************************/
  //Display msg
  function demoProductCount(){
    let totalqty_tot = 0;
    $('.cart-drawer-min .cdmset').each(function(index,item){
      totalqty_tot = totalqty_tot + 1;
    });
    if(totalqty_tot == 0){
      if(!$(".cart-drawer-set").find(".nofound").length){
        $(".cart-drawer-last").css("display","none");
        $("div#globoCart").css("display","none");
        $(".cart-drawer-set").append('<div class="nofound"><h3>Your cart is empty</h3><a href="/collections/all" class="button">Continue Shopping</a></div>');
      }
    }
    if($('#product-grid').length > 0){
      $('#product-grid li .quick-add').find('.plus-cart-icon-msg').hide();
      //$('div#recommend_demo ul#product-grid li .card > .card__inner .quick-add .added-item-msg').html('');
      $('ul#product-grid li .card > .card__inner .quick-add .added-item-msg').html('');
      // let qty_tot = $('.cart-drawer-min .cdmset').length;
      let newqty_tot = 1;
      $('.cart-drawer-min .cdmset').each(function(index,item){
        let dataitem = $(this).attr('data');
        if(dataitem){
          if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
            newqty_tot = newqty_tot + 1;
          }
        }
      });
      $('.cart-drawer-min .cdmset').each(function(index,item){
        let dataitem = $(this).attr('data');
        if(dataitem){
          if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
            let lineItemKey = $(this).find('.cdmsetr .pn-price-item').data('id');
            newqty_tot = newqty_tot - 1;
            let variantTitle = '';
            let variantTitle1 = 'is in your demo list.';
            if($.trim($(this).find('.cdminfo').text()) !==''){
              variantTitle = $(this).find('.cdminfo').text().replace('(STANDARD)','');
              variantTitle = variantTitle.replace('(Standard)','');
              variantTitle = 'Added: '+variantTitle.replace('(standard)','');
              variantTitle1 = '';
            } else{
              variantTitle = 'Added';
              variantTitle1 = '';
            }
            $('ul#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text().trim()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.added-item-msg').append('<span class="lineitem-data" data-key="'+lineItemKey+'"><span class="lineitem-title">'+variantTitle+'</span>&nbsp; '+variantTitle1+' (<span class="plus-icon-cart-count">'+newqty_tot+'&nbsp;</span> of 4)</span>');
            $('ul#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text().trim()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-cart-icon-msg').show();
          }
        }
      });
      //alert(qty_tot);
      let checkqty_tot = $('.cart-drawer-min .cdmset').length;
      //  alert(qty_tot);
         var newcount = 4 - parseInt(checkqty_tot) ;
        // alert(newcount);
              if(checkqty_tot == 4){
              var newquiztitle = '';
                if($("div#recommend_demo facet-filters-form").find(".facets.facets-vertical-sort.page-width.quiz-product-main-title")){
                   newquiztitle +=`
                      <h2>Nice! Let's wrap this up.</h2>
                      <div style="
      display: flex;
      margin-bottom: 35px;
      text-align: center;
      display: inline-grid;
  " class="view_Cart_demoapi"><a href="/cart" style="
      width: 198px;
      height: 52px;
      /* left: 621px; */
      /* top: 266px; */
  
  /* Black */
      background: #212120;
  /* Grey */
      border: 0.5px solid #666666;
      padding-top: 15px;
      display: inline;
      color: white;
      text-decoration: none;
  ">View Cart</a>
                  </div>`;
                  $("div#recommend_demo .facets.facets-vertical-sort.page-width.quiz-product-main-title").html(newquiztitle);
                }else{
                   newquiztitle +=`<div class="facets facets-vertical-sort page-width quiz-product-main-title">
                      <h2>Nice! Let's wrap this up.</h2>
                      <div style="
      display: flex;
      margin-bottom: 35px;
      text-align: center;
      display: inline-grid;
  " class="view_Cart_demoapi"><a href="/cart" style="
      width: 198px;
      height: 52px;
      /* left: 621px; */
      /* top: 266px; */
  
  /* Black */
      background: #212120;
  /* Grey */
      border: 0.5px solid #666666;
      padding-top: 15px;
      display: inline;
      color: white;
      text-decoration: none;
  ">View Cart</a></div>
                  </div>`;
                  $("div#recommend_demo facet-filters-form.facets.facets-vertical-sort.page-width.small-hide.no-js-hidden").prepend(newquiztitle);
                }
              }else if(checkqty_tot < 4 && checkqty_tot >= 0){
  
                var newquiztitle = '';
                if($("div#recommend_demo facet-filters-form").find(".facets.facets-vertical-sort.page-width.quiz-product-main-title")){
                   
                   newquiztitle +=`
                      <h2>Select <span id="quiz-product-count">${newcount}</span> paddles to try during the Demo Program.</h2>
                  `;
  
                  $("div#recommend_demo .facets.facets-vertical-sort.page-width.quiz-product-main-title").html(newquiztitle);
                 // alert(newquiztitle);
                }else{
                   
                   newquiztitle +=`<div class="facets facets-vertical-sort page-width quiz-product-main-title">
                      <h2>Select <span id="quiz-product-count">${newcount}</span> paddles to try during the Demo Program.</h2>
                  </div>`;
                  
                  $("div#recommend_demo facet-filters-form.facets.facets-vertical-sort.page-width.small-hide.no-js-hidden").prepend(newquiztitle);
                  //alert(newquiztitle);
                }
             //  return false;
              }
  
  
      }
  }

})();
